import { UserSession } from '../auth.types';
import { ZidAuthLocalStorageKeys, ZidAuthSessionStorageKeys, ZidAuthUrlParams } from './tokenUtils';

export const getCurrentUser = async (): Promise<void> => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get(ZidAuthUrlParams.code);

  if (code || sessionStorage.getItem(ZidAuthSessionStorageKeys.oauthState)) {
    return;
  }

  const idToken = localStorage.getItem(ZidAuthLocalStorageKeys.idToken);
  const session: UserSession = JSON.parse(localStorage.getItem(ZidAuthLocalStorageKeys.session) || '{}');

  if (!idToken || !session) {
    throw new Error('User is not authenticated.');
  }
};
